
import { useForm } from "react-hook-form";

import {
    Col,
    Row
} from "react-bootstrap";
import RenderField from "../RenderField";

const Experience = ({register}) => {
    const {  formState: { errors } } = useForm();

    return (
        <div className="w-full px-4">
        <p className={'text-center p-4 text-2xl font-light'}>Work Experience</p>
    
            <Row md={"auto"} >
                <Col md={6}>
                    <RenderField name={'employer'} label={"Current Employer"} placeholder={''} required={true} register={register} errors={errors} maxLength={50}/>
                </Col>
      
                <Col md={6}>
                    <RenderField size={'small'} type={'number'} label={'Years of Expererience'} className={'form-control'} placeholder={''} name={'experience'} required={true} register={register} errors={errors} />
                </Col>
             
            </Row>
            
    
    </div>
    )
}

export default Experience